"use client";

import { Button } from "@npm_leadtech/qr-ui-components";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { useWifiData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";
import { useTranslation } from "react-i18next";

import "./WifiTemplate.scss";

export const WifiTemplate = (props: QRProps<"wifi">) => {
  const { t } = useTranslation("wifi");
  const { data, isInitialPreview, qrNetworkName } = useWifiData(props);

  if (!data) {
    return null;
  }

  const networkName = qrNetworkName || "Central Cafe";

  return (
    <PhoneLayout
      page="wifi"
      dataQA="preview-wifi-container"
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <div className="wifi-template">
        <div className="wifi-template__content">
          <div className="wifi-template__text">{t("preview_text")}</div>
          <div className="wifi-template__network-name">
            {qrNetworkName ? `"${qrNetworkName}"?` : `"${networkName}"?`}
          </div>
        </div>
        <div className="wifi-template__buttons">
          <Button
            shape="outlined"
            label={t("preview_cancel_button_label")}
            ariaLabel="No, cancel"
            dataQA="no-connect"
            onClick={() => {}}
            size="small"
          />
          <Button
            label={t("preview_connect_button_label")}
            ariaLabel="Yes, connect"
            dataQA="yes-connect"
            onClick={() => {}}
            size="small"
          />
        </div>
      </div>
    </PhoneLayout>
  );
};
